"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePanelPreferencesByNuclei = exports.usePanelPreferences = void 0;
const has_1 = __importDefault(require("lodash/has"));
const react_1 = require("react");
const PredictionManager_1 = require("../../data/PredictionManager");
const PreferencesContext_1 = require("../context/PreferencesContext");
const panelsPreferencesDefaultValues_1 = require("../reducer/preferences/panelsPreferencesDefaultValues");
const LocalStorage_1 = require("../utility/LocalStorage");
const basePath = 'formatting.panels';
function getDefaultPreferences(panelKey, nucleus) {
    switch (panelKey) {
        case 'spectra':
            return (0, panelsPreferencesDefaultValues_1.getSpectraDefaultValues)(nucleus);
        case 'peaks':
            return (0, panelsPreferencesDefaultValues_1.getPeaksDefaultValues)(nucleus);
        case 'integrals':
            return (0, panelsPreferencesDefaultValues_1.getIntegralDefaultValues)(nucleus);
        case 'ranges':
            return (0, panelsPreferencesDefaultValues_1.getRangeDefaultValues)(nucleus);
        case 'zones':
            return (0, panelsPreferencesDefaultValues_1.getZoneDefaultValues)(nucleus);
        case 'database':
            return panelsPreferencesDefaultValues_1.databaseDefaultValues;
        case 'multipleSpectraAnalysis':
            return (0, panelsPreferencesDefaultValues_1.getMultipleSpectraAnalysisDefaultValues)(nucleus);
        case 'prediction':
            return (0, PredictionManager_1.getDefaultPredictionOptions)();
        default:
            return {};
    }
}
function joinWithNucleusPreferences(data, nucleus, returnOnlyNucleusPreferences = false) {
    const { nuclei = {}, ...rest } = data;
    if (returnOnlyNucleusPreferences) {
        return nuclei?.[nucleus];
    }
    return { ...nuclei[nucleus], ...rest };
}
function getPanelPreferences(preferences, panelKey, nucleus, returnOnlyNucleusPreferences = false) {
    const panelPath = `${basePath}.${panelKey}`;
    let path = panelPath;
    if (nucleus) {
        switch (panelKey) {
            case 'multipleSpectraAnalysis':
            case 'matrixGeneration':
                path = `${panelPath}.${nucleus}`;
                break;
            default:
                path = `${panelPath}.nuclei.${nucleus}`;
                break;
        }
    }
    let panelPreferences = {};
    if ((0, has_1.default)(preferences, path)) {
        panelPreferences = (0, LocalStorage_1.getValue)(preferences, panelPath, {});
    }
    else {
        panelPreferences = getDefaultPreferences(panelKey, nucleus);
    }
    switch (panelKey) {
        case 'multipleSpectraAnalysis':
        case 'matrixGeneration':
            return nucleus ? panelPreferences[nucleus] : {};
        case 'database':
        case 'prediction':
            return panelPreferences;
        default:
            return nucleus
                ? joinWithNucleusPreferences(panelPreferences, nucleus, returnOnlyNucleusPreferences)
                : {};
    }
}
function usePanelPreferences(panelKey, nucleus) {
    const { current } = (0, PreferencesContext_1.usePreferences)();
    return (0, react_1.useMemo)(() => {
        return getPanelPreferences(current, panelKey, nucleus);
    }, [current, nucleus, panelKey]);
}
exports.usePanelPreferences = usePanelPreferences;
function usePanelPreferencesByNuclei(panelKey, nuclei) {
    const { current } = (0, PreferencesContext_1.usePreferences)();
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { nuclei: omitNuclei = null, ...restPreferences } = getPanelPreferences(current, panelKey);
    return (0, react_1.useMemo)(() => {
        return {
            nuclei: Object.fromEntries(nuclei.map((nucleusLabel) => [
                nucleusLabel,
                getPanelPreferences(current, panelKey, nucleusLabel, true),
            ])),
            ...restPreferences,
        };
    }, [current, nuclei, panelKey, restPreferences]);
}
exports.usePanelPreferencesByNuclei = usePanelPreferencesByNuclei;
